export default {
  time_options: {
    asap: {
      title: 'Schnellstmöglich ',
      description: 'Fertig in {{time}} min',
    },
    scheduled: {
      title: 'Planen für später',
    },
  },
};
